export const searchNormalized = (name: string, searchText: string) => {
    const nameNormalized = name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

    const normalizedSearchText = searchText
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

    const matchIndex = nameNormalized.indexOf(normalizedSearchText);

    if (matchIndex === -1) return false;
    return true;
}

export const sortedPerAvailabilityList = <
    T extends
    | TCategoriesWithProducts[]
>(
    groups: T
): T => {
    return groups.sort((a, b) => {
        if (
            (a.total_products > 0 && b.total_products === 0)
        ) {
            return -1;
        } else if (
            (a.total_products === 0 && b.total_products > 0)
        ) {
            return 1;
        }
        return 0;
    }) as T;
};
